import React from 'react';

// Vertical KPI rail used in the cockpit layout. Each row is a clickable
// metric. The active row gets an animated 2px left accent bar and a
// slightly elevated background so the user always knows which canvas
// view they are looking at. Animations honor `prefers-reduced-motion`.

export default function KpiRail({ metrics, activeId, onSelect, className = '' }) {
  return (
    <div
      className={`flex h-full flex-col overflow-hidden rounded-xl border border-zinc-200 bg-white shadow-sm ${className}`}
    >
      <div className="flex items-center justify-between border-b border-zinc-100 px-3 py-2">
        <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-zinc-500">
          Key metrics
        </span>
        <span className="text-[10px] text-zinc-400">{metrics.length}</span>
      </div>
      <ul className="flex-1 overflow-y-auto py-1">
        {metrics.map((m) => {
          const active = activeId === m.id;
          return (
            <li key={m.id}>
              <button
                type="button"
                onClick={() => onSelect?.(m)}
                title={m.hint || ''}
                aria-pressed={active}
                className={`group relative flex w-full items-start gap-2 px-3 py-2 text-left transition-colors duration-150 motion-reduce:transition-none ${
                  active
                    ? 'bg-zinc-50'
                    : 'hover:bg-zinc-50/70'
                }`}
              >
                {/* Animated left accent bar */}
                <span
                  aria-hidden
                  className={`absolute left-0 top-1.5 h-[calc(100%-12px)] w-[2px] origin-top rounded-r-full bg-zinc-900 transition-transform duration-200 ease-out motion-reduce:transition-none ${
                    active ? 'scale-y-100' : 'scale-y-0'
                  }`}
                />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-1">
                    <span className={`text-[10px] font-semibold uppercase tracking-wider ${active ? 'text-zinc-700' : 'text-zinc-500'}`}>
                      {m.label}
                    </span>
                    {m.trend ? (
                      <span className="rounded bg-emerald-50 px-1 py-0.5 text-[9px] font-semibold text-emerald-700">
                        {m.trend}
                      </span>
                    ) : null}
                  </div>
                  <div
                    className={`mt-0.5 text-[15px] font-semibold tabular-nums leading-tight tracking-tight ${
                      active ? 'text-zinc-900' : 'text-zinc-900'
                    }`}
                  >
                    {m.value}
                  </div>
                  {m.sublabel ? (
                    <div className="truncate text-[10.5px] text-zinc-500">{m.sublabel}</div>
                  ) : null}
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
